export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
export const SET_USER_LOADING = 'SET_USER_LOADING';

// Configurations
export const SET_CONFIGURATION_SETTINGS = 'SET_CONFIGURATION_SETTINGS';
export const SET_PDF_GEN_ACTIVITY = 'SET_PDF_GEN_ACTIVITY';
export const RESET_PDF_GEN_ACTIVITY = 'RESET_PDF_GEN_ACTIVITY';

// Project Module
export const SET_USER_PROJECTS = 'SET_USER_PROJECTS';
export const SET_PROJECT_LOCKING_STATUS = 'SET_PROJECT_LOCKING_STATUS';
export const SET_ACTIVE_PROJECT = 'SET_ACTIVE_PROJECT';
export const SET_ACTIVE_PROJECT_STATISTICS = 'SET_ACTIVE_PROJECT_STATISTICS';
export const PROJECT_INFO = 'PROJECT_INFO';

/** @deprecated Use PROJECT_INFO — kept for migration from persisted devtools snapshots. */
export const PRIJECT_INFO = PROJECT_INFO;

// Entity Manager Module
export const SET_ENTITY_MANAGER_FORMS = 'SET_ENTITY_MANAGER_FORMS';

// System slice
export const SET_FIELDS = 'SET_FIELDS';
export const SET_TAG_SETTING = 'SET_TAG_SETTING';
export const MY_OFFICES = 'MY_OFFICES';
export const MY_NOTES = 'MY_NOTES';
export const USER_CONTACT = 'USER_CONTACT';
